import React, { useReducer, createContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import Divider from '@material-ui/core/Divider';
import FreightsActionsButtons from './FreightsActionsButtons';
import { __ } from '../../../../../utils/i18n';
import FreightsSearchBox from './FreightsSearchBox';
import FreightsList from './FreightsList';
import { initialState, reducer, actions } from './reducer';
import { makeStyles } from '@material-ui/core/styles';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
}));

export const store = createContext(null);
const { Provider } = store;

const Freights = () => {
  useTitle('مدیریت باربری‌ها');
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Provider value={{ state, dispatch, actions }}>
      <FullCard title="مدیریت باربری‌ها" actions={<FreightsActionsButtons />}>
        <div className={classes.root}>
          <FreightsSearchBox />
          <Divider />
          <FreightsList />
        </div>
      </FullCard>
    </Provider>
  );
};

export default React.memo(Freights);
